const e=({typography:t})=>({styleOverrides:{root:{marginLeft:0,marginTop:4,display:"flex",alignItems:"center",...t.caption}}});export{e as default};
